import { Component } from '@angular/core';
import { default as getTenantConfig, ValmetDnaTagConfig } from '~app/shared/map/layer/layer-definitions/T14';

@Component({
  selector: 'qm-neve-measurements',
  templateUrl: './neve-measurements.component.html',
  //styleUrls: ['./neve-measurements.component.scss']
})
export class NeveMeasurementsComponent {
  public mainNetworkTags: ValmetDnaTagConfig[];
  public auxiliaryNetworkTags: ValmetDnaTagConfig[];

  constructor() {
    const { mainNetwork, auxiliaryNetwork } = getTenantConfig().tenantCustomData.valmetDnaTags.powerInfo;
    this.mainNetworkTags = mainNetwork;
    this.auxiliaryNetworkTags = auxiliaryNetwork;
  }
}
